import request, { IServerResponse } from '@/utils/request';
import { AccountDetail } from './define';

// 查询余额提现详情
export const  getAccountDetails= (params: any): Promise<IServerResponse<Array<AccountDetail>>> => {
    return request.get('/api/thirdpartnar/account/balance/withdrawal', params);
}